import React from 'react';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';

interface SectionWrapperProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  [key: string]: any;
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({ children, sx, ...props }) => (
  <Box
    {...props}
    sx={{
      width: '100%',
      maxWidth: '1760px',
      mx: 'auto',
      px: '10px',
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default SectionWrapper; 